import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-2">
        Your privacy is important to us. This policy outlines how we collect, use, and protect your data.
      </p>
      <ul className="list-disc list-inside space-y-2">
        <li>We collect personal information such as your name, gender, home and office addresses to provide ride booking services.</li>
        <li>Data is used strictly for providing and improving user experience.</li>
        <li>We do not share your personal data with third parties without consent, except where required by law.</li>
        <li>Your data is stored securely and encrypted where applicable.</li>
        <li>You may request deletion or modification of your personal data at any time.</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;